import {
  RouteInterface,
  CcfHome,
  CcfPreviewImage
} from '@nice-ccf/ui-components';
import { Redirect } from 'react-router-dom';
import Simulator from '../simulator/simulator';
import { Box } from '@mui/material';
import Admin from '../admin/admin';
import PrivateRoute from './privateRoute';
import SimulatorV2 from '../simulator-v2/simulator-v2';
import IconsLibrary from '../icons-library/icons-library';
export const routes: RouteInterface[] = [
  {
    path: '/agent/home',
    private: false, //disable login for local development
    component: <CcfHome />,
    children: [
      {
        path: '/agent/home/previewMode',
        private: false,
        component: (
          <Box display="flex" marginX={2} marginY={1.5} flex="1">
            <CcfPreviewImage isOpen={true} imgIndex={0} />
          </Box>
        ),
      },
    ],
  },
  {
    path: '/simulator-v2',
    private: false,
    component: <SimulatorV2 />,
  },
  {
    path: '/admin',
    private: false,
    component: <PrivateRoute component={Admin} />,
  },
  {
    path: '/iconslibrary',
    private: false,
    component: <IconsLibrary />,
  },
  {
    path: '*',
    private: false,
    component: <Redirect to="/agent/home" />,
  },
];
